import { ACTION_TYPES } from '~/core/constants'
import { isMeetingSharingEnabled } from '~/selectors/settings'
import { getLatestRecents } from '../actions/recents'

export default store => next => action => {
  switch (action.type) {
    case ACTION_TYPES.SETTINGS.SET_USER_SETTINGS: {
      const { allowMeetingSharing, isInit } = action.payload || {}

      const prevAllowMeetingSharing = isMeetingSharingEnabled(store.getState())
      const shouldFetchLatestRecents = allowMeetingSharing && allowMeetingSharing !== prevAllowMeetingSharing
      !isInit && shouldFetchLatestRecents && store.dispatch(getLatestRecents())

      next(action)
      break
    }
    default:
      next(action)
  }
}
